import { attr, oneToOne, fk} from 'redux-orm';
import Model from '../base-model';
import { unitActions } from './unit.action';
import unitReducers from './unit.reducer';
import quizReducers from '../quiz/quiz.reducer';

/**
 * Unit
 * @typedef {Object} Unit
 * @property {string} id
 * @property {string} title
 * @property {string} type
 * @property {string} description
 * @property {boolean} isSeen
 */

export class Unit extends Model {

    save(unit) {
        this.create(unit)
    }

    static reducer(action, Self, session) {
        switch (action.type) {
        case unitActions.savePdfUnit:
            unitReducers.savePdfUnit(session, action.pdfDetail, action.id);
            break;
        case unitActions.saveVideoUnit:
            unitReducers.saveVideoUnit(session, action.videoDetail, action.id);
            break;
        case unitActions.saveQuizUnit:
            const quizModel = quizReducers.saveQuiz(session, action.quiz);
            unitReducers.saveQuizUnit(session, quizModel.id, action.id);
            break;
        case unitActions.setSeenUnitFlag:
            unitReducers.setSeenUnitFlag(session, action.unitId, action.isSeen);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Unit: ${this.title}`
    }
}

Unit.modelName = 'Unit';

Unit.fields = {
    id: attr(),
    title: attr(),
    type: attr(),
    isSeen: attr(),
    description: attr(),
}

/**
 * PdfUnit
 * @typedef {Object} PdfUnit
 * @property {string} id
 * @property {string} title
 * @property {string} filePath
 * @property {string} unitId
 */

export class PdfUnit extends Model {


    toString() {
        return `Unit: ${this.title}`
    }
}

PdfUnit.modelName = 'PdfUnit';

PdfUnit.fields = {
    id: attr(),
    title: attr(),
    filePath: attr(),
    unit: oneToOne('Unit', 'fileType'),
}

/**
 * VideoUnit
 * @typedef {Object} VideoUnit
 * @property {string} id
 * @property {string} title
 * @property {string} filePath
 * @property {string} unitId
 */

export class VideoUnit extends Model {


    toString() {
        return `Unit: ${this.title}`
    }
}

VideoUnit.modelName = 'VideoUnit';

VideoUnit.fields = {
    id: attr(),
    title: attr(),
    filePath: attr(),
    currentTime: attr(),
    attachments: attr(),
    unit: oneToOne('Unit', 'videoType'),
}

/**
 * QuizUnit
 * @typedef {Object} QuizUnit
 * @property {string} id
 * @property {Quiz} quiz
 * @property {Unit} unit
 * @property {number} correctCount
 * @property {number} wrongCount
 * @property {number} notAnsweredCount
 * @property {number} grade
 */

export class QuizUnit extends Model {

    toString() {
        return `QuizUnit: ${this.title}`
    }
}

QuizUnit.modelName = 'QuizUnit';

QuizUnit.fields = {
    id: attr(),
    quiz: fk('Quiz', 'quizUnit'),
    unit: oneToOne('Unit', 'quizType'),
    startAt: attr(),
}